import { render, staticRenderFns } from "./game-header.vue?vue&type=template&id=55343714&scoped=true"
import script from "./game-header.vue?vue&type=script&lang=js"
export * from "./game-header.vue?vue&type=script&lang=js"
import style0 from "./game-header.vue?vue&type=style&index=0&id=55343714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55343714",
  null
  
)

export default component.exports